// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  value: string,
  label: string,
  labelVariables? : {[key: string] : string}
}

export default class KpiSelector extends React.PureComponent<Props> {
  static defaultProps = {
    labelVariables: {},
  };
  render() {
    const { value, label } = this.props;
    return (
      <div className="kpi-selector-row description">
        <div className="kpi-selector description">
          <Translate value={label} {...this.props.labelVariables}/>
          <div className="data-value"> {value} </div>
        </div>
      </div>
    );
  }
}
